import React, { memo, useEffect, useState, useCallback, useRef } from 'react';
import styles from './WpProductDownloadPath.module.less';
import Dialog from '../Dialog/Modal';
import { PCStoreJsBridge } from '../../nativeapi';
import Btn from '../Btn/Btn';
import Toast from '../Toast/Toast';
import { logNative } from '../../utils/utils';
import { WP_DOWNLOAD } from '../../constants/storageKeys';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { logging } from '../../actions/log';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);
export default memo(({ handleCancelDialog = () => {}, wallpaper = {} }) => {
  const [path, setPath] = useState(undefined);
  const node = useRef(null);
  const logInfoData = useSelector(selectLogInfo);
  const dispatch = useDispatch();

  const handleWpDownPathLog = useCallback(() => {
    dispatch(
      logging({
        category: 'Wallpaper',
        action: 'P_Wallpaper_Pathset',
        label: '',
        param2: {
          source: `${logInfoData.source}`,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          wptype: wallpaper.type,
          wallpaperId: wallpaper.type !== 2 ? wallpaper.wallpaperId : wallpaper.code,
        },
        param3: wallpaper?.bizInfo || '{}',
      }),
    );
  }, [logInfoData, wallpaper]);

  const handleUpdateWpDownPathLog = useCallback(() => {
    dispatch(
      logging({
        category: 'Wallpaper',
        action: 'C_Wallpaper_Pathset',
        label: '',
        param2: {
          source: `${logInfoData.source}`,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          wptype: wallpaper.type,
          wallpaperId: wallpaper.type !== 2 ? wallpaper.wallpaperId : wallpaper.code,
        },
        param3: wallpaper?.bizInfo || '{}',
      }),
    );
  }, [logInfoData, wallpaper]);
  const handleResultWpDownPathLog = useCallback(
    ({ status = 1, mes = '' }) => {
      dispatch(
        logging({
          category: 'Wallpaper',
          action: 'R_Wallpaper_Pathset',
          label: '',
          param2: {
            source: `${logInfoData.source}`,
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            wptype: wallpaper.type,
            wallpaperId: wallpaper.type !== 2 ? wallpaper.wallpaperId : wallpaper.code,
            status,
            mes,
          },
          param3: wallpaper?.bizInfo || '{}',
        }),
      );
    },
    [wallpaper],
  );

  const getHasSetPath = useCallback(() => {
    PCStoreJsBridge.getWallpaperDPath().then(res => {
      setPath(res.workpath);
    });
  }, []);

  const setWpPath = useCallback(() => {
    PCStoreJsBridge.setWallpaperDPath(path).then(res => {
      if (res.succ) {
        handleCancelDialog('down');
      } else {
        Toast.error({
          content: res.msg,
        });
      }
    });
  }, [path]);

  const handleBrowserFolder = useCallback(() => {
    handleUpdateWpDownPathLog();
    PCStoreJsBridge.browserFolder(path).then(res => {
      if (res.DownLoadPath) {
        setPath(res.DownLoadPath);
        handleResultWpDownPathLog();
      }
    });
  }, []);

  useEffect(() => {
    getHasSetPath();
    try {
      window.external.inde_set_kivi(JSON.stringify({ ki: WP_DOWNLOAD, vi: Date.now() }));
    } catch (err) {
      logNative(`设置壁纸是否下载${err}`);
    }
  }, []);

  useEffect(() => {
    // 展现打桩
    handleWpDownPathLog();
  }, []);

  return (
    <Dialog
      title="下载提示"
      maskStyle={styles.mask}
      containerStyle={styles.containerStyle}
      handleClose={handleCancelDialog}
    >
      <div className={styles.contianer}>
        <div className={styles.title}>我们将下载壁纸至以下路径：</div>
        <div className={styles.path}>
          <input
            type="text"
            className={styles.path_input}
            readOnly
            ref={node}
            defaultValue={path}
          />
          <div className={styles.path_btn} onClick={handleBrowserFolder}>
            修改下载路径
          </div>
        </div>
        <Btn primary={true} className={styles.btn_confirm} handleClick={setWpPath}>
          确认
        </Btn>
      </div>
    </Dialog>
  );
});
